<div class="full-width flex justify-between p-3 bg-gray-400 items-center">
  <div class="flex items-center">
    <app-main-button (click)="navigateBack()">Zurück</app-main-button>
  </div>
  <div class="flex items-center">
    <ng-container *ngIf="!editMode; else editModeButton">
      <app-main-button class="pr-3" (click)="switchToEditMode()">
        <span nz-icon nzType="edit"></span>
        Bearbeiten
      </app-main-button>
      <ng-container *ngIf="person$ | async as person">
        <a nz-dropdown [nzDropdownMenu]="menu">
          <app-main-button type="secondary">
            Schlüsselaktionen <span nz-icon nzType="down"></span>
          </app-main-button>
        </a>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="onAssignClick()">
              <span nz-icon nzType="user-add"></span>
              Zuweisen
            </li>
            <ng-container *ngFor="let locker of person.spinde">
              <ng-container
                *ngIf="
                  locker.zweitschluessel_ausgegeben_am !== null;
                  else noSecondKey
                "
              >
                <li nz-menu-item (click)="onWithdrawSecondKeyClick(locker)">
                  <span nz-icon nzType="key"></span>
                  2. Schlüsselrücknahme ({{ locker.bezeichnung }})
                </li>
              </ng-container>
              <ng-template #noSecondKey>
                <li nz-menu-item (click)="onReleaseLockerClick(locker)">
                  <span nz-icon nzType="key"></span>
                  Schlüsselrücknahme ({{ locker.bezeichnung }})
                </li>
                <li nz-menu-item (click)="onHandoutSecondKey(locker)">
                  <span nz-icon nzType="key"></span>
                  2. Schlüsselausgabe ({{ locker.bezeichnung }})
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </nz-dropdown-menu>
      </ng-container>
    </ng-container>
    <ng-template #editModeButton>
      <app-main-button class="pr-3" (click)="savePerson()">
        <span nz-icon nzType="save"></span>
        Speichern
      </app-main-button>
      <app-main-button type="danger" (click)="cancel()">
        <span nz-icon nzType="close"></span>
        Abbrechen
      </app-main-button>
    </ng-template>
  </div>
</div>

<div class="p-10">
  <ng-container *ngIf="person$ as person; else loading">
    <h2 class="text-3xl text-primary pb-12" [ngClass]="{ 'pb-5': avsPerson }">
      Personendetails
    </h2>

    <div class="flex-row justify-between">
      <ng-container *ngIf="avsPerson">
        <div class="flex pb-5">
          <nz-alert
            nzType="warning"
            nzShowIcon=""
            nzMessage="Name, Geschlecht und Firma dieser Person können nur im AVS aktualisiert
        werden"
          >
          </nz-alert>
        </div>
      </ng-container>
      <div class="flex pb-5">
        <span
          nz-tooltip
          nzTooltipTitle="Verwenden Sie einfach den Handscanner, um eine Kleidungsstück
                oder eine Person zu scannen."
        >
          <nz-alert
            nzType="warning"
            nzShowIcon=""
            nzMessage="Scanfunktion aktiv"
          >
          </nz-alert>
        </span>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-5 pt-3">
      <div class="sm: col-span-12 md:col-span-12 xl:col-span-12">
        <form
          [formGroup]="validatePersonForm"
          [ngClass]="{ 'readonly-select': !editMode }"
          class="pb-5 grid grid-cols-1 md:grid-cols-2 gap-5"
        >
          <app-form-input
            class="col-span-1"
            label="Vorname"
            attribute="vorname"
            [readOnly]="isReadOnly(avsPerson)"
            subformGroup="mandatoryFields"
          ></app-form-input>

          <app-form-input
            class="col-span-1"
            label="Name"
            attribute="name"
            [readOnly]="isReadOnly(avsPerson)"
            subformGroup="mandatoryFields"
          ></app-form-input>

          <app-form-select
            class="col-span-1"
            label="Geschlecht"
            attribute="geschlecht"
            [readOnly]="isReadOnly(avsPerson)"
            subformGroup="mandatoryFields"
            [selectOptions]="selectOptionsGender"
            valueKey="value"
            labelKey="label"
          ></app-form-select>

          <app-form-input
            class="col-span-1"
            label="Gruppe"
            attribute="gruppe"
            [readOnly]="isReadOnly(avsPerson)"
            subformGroup="mandatoryFields"
          ></app-form-input>

          <app-form-select
            class="col-span-1"
            label="Firma"
            attribute="firmaId"
            [readOnly]="isReadOnly(avsPerson)"
            subformGroup="optionalFields"
            [selectOptions]="companies"
            valueKey="oid"
            labelKey="bezeichnung"
          ></app-form-select>

          <app-form-select
            class="col-span-1"
            label="Hemdgröße"
            attribute="groesse_hemd"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            [selectOptions]="clothingSizes"
            valueKey="codenr"
            labelKey="text"
          ></app-form-select>

          <app-form-select
            class="col-span-1"
            label="Hosengröße"
            attribute="groesse_hose"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            [selectOptions]="clothingSizes"
            valueKey="codenr"
            labelKey="text"
          ></app-form-select>

          <app-form-select
            class="col-span-1"
            label="Jackengröße"
            attribute="groesse_jacke"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            [selectOptions]="clothingSizes"
            valueKey="codenr"
            labelKey="text"
          ></app-form-select>

          <app-form-select
            class="col-span-1"
            label="Kittelgröße"
            attribute="groesse_kittel"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            [selectOptions]="clothingSizes"
            valueKey="codenr"
            labelKey="text"
          ></app-form-select>

          <app-form-select
            class="col-span-1"
            label="Schuhgröße"
            attribute="groesse_schuh"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            [selectOptions]="clothingSizes"
            valueKey="codenr"
            labelKey="text"
          ></app-form-select>

          <app-form-textarea
            class="col-span-1"
            label="Bemerkung"
            attribute="bemerkung"
            [readOnly]="!editMode"
            subformGroup="optionalFields"
            placeholder="Schreiben Sie hier einen Kommentar"
            [maxCharacterCount]="200"
          ></app-form-textarea>
        </form>
      </div>
      <div class="sm:col-span-12 md:col-span-12 xl:col-span-6">
        <ng-container *ngIf="personLockers$ | async as lockers">
          <h2
            class="text-2xl text-primary pb-10"
            [ngClass]="{ 'pb-5': avsPerson }"
            *ngIf="lockers.length > 0"
          >
            Spinddetails
          </h2>
          <div
            *ngFor="let locker of lockers"
            class="grid grid-cols-12 gap-5 pb-5"
          >
            <label class="text-lg text-blue-800 col-span-3">Bezeichnung</label>
            <input
              [readOnly]="true"
              type="text"
              class="col-span-9"
              nz-input
              [ngModel]="locker.bezeichnung + ' (' + locker.spindart + ')'"
            />
          </div>
        </ng-container>

        <ng-container *ngIf="personClothing$ | async as clothing">
          <h2
            *ngIf="clothing.length > 0"
            class="text-2xl text-primary pb-10"
            [ngClass]="{ 'pb-5': avsPerson }"
          >
            Kleiderdetails
          </h2>
          <div
            *ngFor="let item of clothing"
            class="grid grid-cols-12 gap-5 pb-5"
          >
            <label class="text-lg text-blue-800 col-span-3">Bezeichnung</label>
            <input
              [readOnly]="true"
              type="text"
              class="col-span-9"
              nz-input
              [ngModel]="
                item.bezeichnung + ' (ID: ' + item.inventarnummer + ')'
              "
            />
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="grid grid-cols-1 space-y-4">
      <p class="flex justify-center text-gray-600">Lade Personendetails...</p>
      <nz-spin class="flex justify-center" nzSimple></nz-spin>
    </div>
  </ng-template>
</div>

<nz-modal
  [nzFooter]="modalFooter"
  [(nzVisible)]="modalIsVisible"
  nzTitle="Spindzuweisung"
  (nzOnCancel)="handleCancel()"
>
  <ng-container *nzModalContent>
    <p class="pb-5 text-lg font-medium">Spind zum Zuweisen auswählen</p>

    <div class="grid grid-cols-1 gap-5 pb-5">
      <div class="relative">
        <nz-input-group nzSize="large" [nzPrefix]="prefixTemplateLocker">
          <input
            placeholder="Hier Spindbezeichnung eingeben"
            nz-input
            [(ngModel)]="searchTerm"
            [nzAutocomplete]="auto"
            (input)="onInput()"
            class="w-full"
          />
          <nz-autocomplete #auto>
            <nz-auto-option
              *ngFor="let locker of searchedLockers$ | async; let i = index"
              [nzValue]="locker.id"
              [nzLabel]="locker.bezeichnung"
            >
              {{ locker.bezeichnung }} ({{ locker.spindart }})
            </nz-auto-option>
          </nz-autocomplete>
        </nz-input-group>

        <nz-spin
          *ngIf="isLoading"
          nzSimple
          class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-10"
        ></nz-spin>

        <ng-template #prefixTemplateLocker>
          <span nz-icon nzType="inbox"></span>
        </ng-template>
      </div>

      <div>
        <nz-range-picker
          class="w-full"
          nzSize="large"
          nzFormat="dd/MM/yyyy"
          [(ngModel)]="date"
        ></nz-range-picker>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #modalFooter>
  <div class="flex justify-end">
    <app-main-button (click)="handleOk()">Spind zuweisen</app-main-button>
    <app-main-button type="danger" (click)="handleCancel()"
      >Abbrechen
    </app-main-button>
  </div>
</ng-template>
